window.initPriceTimerSync = function(){
  function parseCentsFromDisplay(display){
    if(!display) return null;
    var currencySymbol = window.cartCurrencySymbol || 'kr';
    var cleaned = String(display).replace(new RegExp(currencySymbol, 'g'),'').trim();
    cleaned = cleaned.replace(/[^0-9.,]/g,'');
    if(cleaned.indexOf('.') !== -1 && cleaned.indexOf(',') !== -1){ cleaned = cleaned.replace(/\./g,'').replace(/,/,'.'); }
    else { cleaned = cleaned.replace(/,/,'.'); }
    var num = parseFloat(cleaned);
    if(isNaN(num)) return null;
    return Math.round(num * 100);
  }

  function formatBspFromCents(cents){
    if(cents == null) return ''; var c = Number(cents); if(isNaN(c)) return ''; var major = Math.floor(c/100); var centsPart = Math.abs(c%100); var centsStr = centsPart < 10 ? '0'+centsPart : String(centsPart); return '['+major+'.'+centsStr+']';
  }

  function ensureHiddenInputs(form){
    if(!form) return;
    var keys = ['_bsp','_bsf','_bsa','_bsmv','_Rabat pris','_bsmc','_bsm_link'];
    keys.forEach(function(k){
      if(!form.querySelector('input[name="properties['+k+']"]')){
        var inp = document.createElement('input'); inp.type = 'hidden'; inp.name = 'properties['+k+']'; inp.value = '';
        form.appendChild(inp);
      }
    });
  }

  function updateBspFromPrice(priceEl){
    if(!priceEl) return;
    var form = priceEl.closest('form');
    if(!form) form = document.querySelector('form[action*="/cart/add"]');
    ensureHiddenInputs(form);
    var bspInput = form.querySelector('input[name="properties[_bsp]"]');
    if(!bspInput) return;
    var display = priceEl.getAttribute('data-timer-adjustable-price') || priceEl.textContent;
    var cents = parseCentsFromDisplay(display);
    if(cents == null) return;
    bspInput.value = formatBspFromCents(cents);
    // flag that timer adjusted
    var bsf = form.querySelector('input[name="properties[_bsf]"]'); if(bsf) bsf.value = 'true';
    var bsa = form.querySelector('input[name="properties[_bsa]"]'); if(bsa) bsa.value = 'true';
  }

  var priceEl = document.querySelector('[data-timer-adjustable-price]');
  var form = document.querySelector('form[action*="/cart/add"]');
  if(form) ensureHiddenInputs(form);
  if(!priceEl) return;
  // initial update
  updateBspFromPrice(priceEl);
  // observe changes
  var mo = new MutationObserver(function(){ updateBspFromPrice(priceEl); });
  mo.observe(priceEl, {attributes: true, childList: true, subtree: true, characterData: true});
};

document.addEventListener('DOMContentLoaded', window.initPriceTimerSync);

// Ensure elements with data-timer-adjustable-price show the adjusted price on load
window.initAdjustedPrices = function(){
  try{
    function applyAdjustedPricesOnce(){
      document.querySelectorAll('[data-timer-adjustable-price]').forEach(function(el){
        var desired = el.getAttribute('data-timer-adjustable-price');
        if(desired){
          // Trim and set text content if different
          if(String(el.textContent).trim() !== String(desired).trim()){
            el.textContent = desired;
          }
        }
      });
    }

    applyAdjustedPricesOnce();

    // Re-apply if theme JS mutates price elements
    document.querySelectorAll('[data-timer-adjustable-price]').forEach(function(el){
      try{
        var mo = new MutationObserver(function(muts){
          var desired = el.getAttribute('data-timer-adjustable-price');
          if(!desired) return;
          if(String(el.textContent).trim() !== String(desired).trim()){
            el.textContent = desired;
          }
        });
        mo.observe(el, {childList: true, characterData: true, subtree: true});
      }catch(e){}
    });
  }catch(e){ console.warn('applyAdjustedPrices error', e); }
};
document.addEventListener('DOMContentLoaded', window.initAdjustedPrices);
